import React, { useState } from 'react'
import { Typography, TextField, Button, IconButton, CardContent } from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import styled from 'styled-components'
import { FlexView } from '../../components/common'
import { toast } from 'react-toastify'
import { useTranslation } from 'react-i18next'

const Instruction = styled.span`
    font-weight: normal;
  color: ${({ theme }) => theme.colors.gray};
  font-size: ${({ theme }) => theme.fontSizes.small};
  text-align: left;
  margin: 0px 5px 34px;
`

const ForgotPasswordForm = ({ setLoading, email, setEmail, updateValue, sendRecoveryCode, recoverPassword, onBackClick }) => {
  const { t } = useTranslation()
  const [hasCode, setHasCode] = useState(false)
  const [confirmPassword, setConfirmPassword] = useState()
  const [recoveryCode, setRecoveryCode] = useState()
  const [newPassword, setNewPassword] = useState()

  const toggleView = () => {
    setHasCode(!hasCode)
  }

  const onSubmit = recoverPassword && sendRecoveryCode && (async e => {
    e.preventDefault()
    if (hasCode) {
      if (confirmPassword === newPassword) {
        setLoading(true)
        try {
          await recoverPassword(email, recoveryCode, newPassword)
          toast.success(t('login.messages.passwordChanged'))
          setLoading(false)
        } catch (e) {
          setLoading(false)
          toast.error('Invalid informations. Please try again.')
        }
     } else {
      toast.error(t('login.errors.PasswordMatchError'))
     } 
    } else {
      setLoading(true)
      try {
        await sendRecoveryCode(email)
      } catch (e) {
      }
      setHasCode(true)
      setLoading(false)
      toast.success(t('login.messages.codeSent'))
    }
  })

  return (
    <CardContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', margin: '20px', marginTop: '0px' }} >
        <input type="hidden" value="something" />
        {hasCode ?
          <>
            <Typography variant="h6" color="textSecondary" component="h2" sx={{ marginBottom: '30px'}}>
              <IconButton aria-label="back" onClick={onBackClick}><ArrowBackIcon /></IconButton>
              {t('login.newPasswordLabel')}
            </Typography>
 
            <Instruction>The new password must have min 8 characters with numbers, uppercase and lowercase letters and especial characters</Instruction>
            
            <TextField id="email" name="email" label="Email" type="email" value={email} required readOnly fullWidth size="small" variant="outlined" InputLabelProps={{shrink: true}}  onChange={updateValue(setEmail)} error={email !== undefined && !email} sx={{ marginBottom: '20px'}} />

            <TextField id="recoveryCode" name="recoveryCode" label={t('recovery code')} value={recoveryCode} required fullWidth size="small" variant="outlined" InputLabelProps={{shrink: true}} onChange={updateValue(setRecoveryCode)} error={recoveryCode !== undefined && !recoveryCode} sx={{ marginBottom: '20px'}} />

            <TextField id="newPassword" name="newPassword" label={t('new password')} value={newPassword} type="password" required fullWidth size="small" variant="outlined" InputLabelProps={{shrink: true}} onChange={updateValue(setNewPassword)} error={newPassword !== undefined && !newPassword} sx={{ marginBottom: '20px'}} />
            
            <TextField id="confirmPassword" name="confirmPassword" label={t('confirm password')} value={confirmPassword} type="password" required fullWidth size="small" variant="outlined" InputLabelProps={{shrink: true}} onChange={updateValue(setConfirmPassword)} error={confirmPassword !== undefined && !confirmPassword} sx={{ marginBottom: '20px'}} />
            
            <FlexView flexDirection="row" alignItems="center" justifyContent="space-between" width="100%" margin="15px 0px 5px">
              <span></span>
              <Button disabled={!email || !recoveryCode || !newPassword || !confirmPassword} variant="contained" onClick={onSubmit}  sx={{ margin: '0px', width: '100px'}}>{t('Change')}</Button>
            </FlexView>
          </>
          :
          <>
            <Typography variant="h6" color="textSecondary" component="h2" sx={{ marginBottom: '30px'}}>
              <IconButton aria-label="back" onClick={onBackClick}><ArrowBackIcon /></IconButton>
              {t('login.forgotPasswordLabel')}
            </Typography>

            <Instruction>{t('login.forgotPasswordInstruction')}</Instruction>
            
            <TextField id="email" name="email" label="Email" type="email" value={email} required readOnly fullWidth size="small" variant="outlined" InputLabelProps={{shrink: true}}  onChange={updateValue(setEmail)}  error={email !== undefined && !email} sx={{ marginBottom: '20px'}} />

            <FlexView flexDirection="row" alignItems="center" justifyContent="space-between" width="100%" margin="15px 0px">
              <Button size="small" onClick={toggleView}>{t('login.alreadyHaveCode')}</Button>
              <Button disabled={!email} variant="contained" onClick={onSubmit}>{t('Send')}</Button>
            </FlexView>
          </>}
    </CardContent>
  )
}

export default ForgotPasswordForm